import axios from "axios";
import { GoogleSlidesApiConfig } from "../../entities/AppConfig";
import { AspectRatios } from "../../entities/AspectRatios";

export interface GoogleSlidesApiResponse {
	error: any;
	presentationId: string;
}

export default class GoogleSlidesHelperService {
	static async PostToGoogleApi(url: string, data: any, headers: any) {
		try {
			const response = await axios(url, {
				method: "post",
				data: data,
				headers: headers,
			});
			return response;
		} catch (ex) {
			const exception = ex as { message: string}
			return {
				status: 400,
				data: {
					error: {
						message: exception.message,
					},
				},
			};
		}
	}

	static getDefaultBackgroundImageUrlById(aspectRatio: AspectRatios, config: GoogleSlidesApiConfig, id: number) {
		if (aspectRatio === "4x3") {
			return config.defaultBackgroundImageUrls.wide.replace("{id}", id.toString());
		}
		return config.defaultBackgroundImageUrls.standard.replace("{id}", id.toString());
	}

	static determineFontSize(length: number) {
		if (length < 252) {
			return 36;
		}
		if (length > 252 && length < 500) {
			return 25;
		}
		if (length > 500 && length < 750) {
			return 20;
		}
		if (length > 750 && length < 1000) {
			return 18;
		}
		if (length > 750 && length < 1000) {
			return 16;
		} else {
			return 14;
		}
	}
}
